import sumBy from 'lodash/sumBy'
import map from 'lodash/map'
import debounce from 'lodash/debounce'
import basketItem from './components/basket-item/index.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import navigateTo from '../../../../mixins/buy-flow'
import { basketDisplayRows, basketRowKind, buildBasketPayloadProducts } from '@/helpers'

export default {
  name: 'buy-flow',
  mixins: [navigateTo],
  data() {
    return {
      kod: '',
      showBonusesInput: false,
      bonusesAmount: 0,
      disabledButton: false,
    }
  },
  components: {
    basketItem,
  },
  mounted() {},
  created() {
    this.sync()
    const transformedProducts = this.basket.map((item) => {
      return {
        item_id: item.select_type.article,
        item_name: item.title,
        affiliation: 'Renew-Cosmetics',
        coupon: '',
        discount: 0.0,
        index: 0,
        item_brand: item.brand?.data?.title || 'Renew',
        item_category: item.brandSeries?.data?.title || '',
        item_category2: (() => {
          if (!this.isAuthenticated) return 'unauthorized'
          if (this.isProfessional) return 'professional'
          if (this.isDistributor) return 'distributor'
          return 'regular'
        })(),
        item_list_id: 'Cosmetics',
        item_list_name: 'Cosmetics',
        location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
        price: Number(item.select_type.price).toFixed(2),
        quantity: item.select_count,
      }
    })

    const sum = this.basket.reduce((acc, item) => {
      return acc + item.select_type.price * item.select_count
    }, 0)

    window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push({
      event: 'view_cart',
      ecommerce: {
        currency: this.currentRegionCurrency || 'EUR',
        value: parseFloat(sum).toFixed(2),
        items: transformedProducts,
      },
    })
  },
  watch: {
    // Rows dropped because the backend no longer knows their price. Removing them
    // silently would look like the basket losing items on its own, so say it once
    // and clear the list - the store only fills it after a sync actually failed.
    unavailableRemoved(items) {
      if (!items || !items.length) return

      // vue-i18n-manager hands back the key itself when the translation table has
      // no row for it, so an unfilled key would show up as raw camelCase on the
      // page. Fall back to a wording that exists in every locale.
      const key = 'basketItemsNoLongerAvailable'
      const text = this.$t(key)

      this.$toasted.error(text && text !== key ? text : this.$t('theGoodsAreOutOfStock'))
      this.setUnavailableRemoved([])
    },
    bonusesAmount() {
      this.setBonuses({ pay_bonus_amount: this.bonusesAmount })
      this.$refs.bonusesError.innerHTML = ''
      this.disabledButton = false

      if (this.bonusesAmount > this.user?.bonusAmount) {
        this.$refs.bonusesError.innerHTML = `${this.$t('available')}  ${this.user.bonusAmount} ${this.$t('bonuses')}`
        this.disabledButton = true
      }
    },
  },
  computed: {
    ...mapGetters({
      basket: 'basket/basket',
      isUserWithCode: 'profile/isUserWithCode',
      user: 'profile/user',
      isDistributor: 'profile/isDistributor',
      isProfessional: 'profile/isProfessional',
      isAuthenticated: 'auth/isAuthenticated',
      promotionResponse: 'basket/promotionResponse',
      currentRegionCurrency: 'regions/currentRegionCurrency',
      allowedGiftCount: 'gifts/allowedGiftCount',
      hasUnselectedGifts: 'gifts/hasUnselectedGifts',
      giftPayloadItems: 'gifts/giftPayloadItems',
      unavailableRemoved: 'basket/unavailableRemoved',
    }),
    // One row per position: a unit a promotion discounted to 0.01 belongs to the
    // position it was split off from, not to a row of its own.
    displayBasket() {
      return basketDisplayRows(this.basket)
    },
    currentRound() {
      return 2
    },
    someProductFree() {
      return this.basket.some((product) => this.isFreePrice(product))
    },
    checkBasketContainsPromotion() {
      return false
      return this.basket.findIndex((product) => product.select_type.hasActivePromotion || product.select_type.hasIndividualDiscount) !== -1
    },
    totalSum() {
      let bonusesAmount = this.bonusesAmount <= this.user?.bonusAmount ? this.bonusesAmount : 0

      return sumBy(this.basket, (product) => (product.select_type.price - product.discount) * product.select_count) - bonusesAmount
    },
    getTempDiscount() {
      return this.hasTempDiscount() ? (this.totalSum * 5) / 100 : 0
    },
    discount() {
      if (!this.canSeeDiscount()) {
        return 0
      }

      let sum = 0

      this.basket.forEach((basketProduct) => {
        const clientPrice = basketProduct.client_price

        // do not calculate for regular users
        if (!clientPrice) {
          return
        }

        let discount = 0

        const price = basketProduct.select_type
        if (this.isProfessional) {
          // for professionals calculate only individual discount
          if (price.hasIndividualDiscount) {
            discount = price.oldPrice - price.price
          }
        } else if (this.isDistributor) {
          // discount = professional price - distributor price
          discount = clientPrice.price - price.price
        } else {
          // for users with code calc actual discount, without promotion percent
          if (clientPrice.hasActivePromotion) {
            discount = clientPrice.oldPrice - price.oldPrice
          } else {
            discount = clientPrice.price - price.price
          }
        }

        sum += discount * basketProduct.select_count
      })

      return sum
    },
  },
  methods: {
    basketRowKind,
    ...mapActions({
      getSyncBasket: 'basket/GET_SYNC_BASKET',
      fetchDefaultPrices: 'basket/GET_DEFAULT_PRICE_BASKET',
      updateUserAssignCode: 'profile/UPDATE_USER_DATA',
      fetchUser: 'profile/FETCH_USER_DATA',
      fetchPromotion: 'basket/FETCH_PROMOTION',
      checkGift: 'gifts/CHECK_GIFT',
    }),
    ...mapMutations({
      changeLoginPopup: 'popups/CHANGE_LOGIN_POPUP',
      setBonuses: 'basket/SET_USER_BONUSES',
      changeSelectGiftPopup: 'popups/CHANGE_SELECT_GIFT_POPUP',
      setUnavailableRemoved: 'basket/SET_UNAVAILABLE_REMOVED',
    }),
    async handleOrderClick() {
      // if (!this.isAuthenticated) {
      //     this.changeLoginPopup(true);
      //     return;
      // }
      await this.checkGift()
      if (this.hasUnselectedGifts) {
        this.changeSelectGiftPopup(true)
        return
      }
      this.navigateTo('buy-flow-order')
    },
    isFreePrice(product) {
      const isSampler = product.type === 'sampler'
      const isFreePrice = product.allProductSum / product.select_count === 0.01
      return isSampler && isFreePrice
    },
    hasTempDiscount() {
      return this.user && this.user.tempDiscount
    },
    canSeeDiscount() {
      return this.user && (this.isUserWithCode || this.isProfessional || this.isDistributor)
    },
    syncProfessional() {
      this.updateUserAssignCode({ professional_id: this.kod })
        .then(() => {
          this.sync()
          this.$toasted.success(this.$t('successChangeCosmetolog'))
        })
        .catch(() => {
          this.$toasted.error(this.$t('errorCodeProfessional'))
        })
    },
    async fetchPromotionData() {
      const payload = {
        products: buildBasketPayloadProducts(this.basket, this.giftPayloadItems),
      }

      try {
        this.promotionResponse = await this.fetchPromotion(payload)
      } catch (e) {
        console.error(e)
      }
    },

    async sync() {
      const ids = map(this.basket, 'id')
      await this.getSyncBasket({ ids })

      if (!this.isAuthenticated) {
        await this.checkGift()
        return
      }

      await this.fetchUser()
      if (this.isUserWithCode || this.isProfessional || this.isDistributor) {
        // await this.fetchDefaultPrices({ ids });
      }
      await this.fetchPromotionData()
      await this.checkGift()
    },
  },
}
